<template>
    <div class="page-warpper indexWinner">  
        <!-- <div class='no-data' v-else></div> -->
        <div class="part-panel" data-index='winnerTable'>
            <div class='w-last'>
                <div class='wl-cnt'>
                    <template  v-for="(item, index) in w10">
                        <img class='wl-img' src="../assets/images/wl/txt1.png" alt="" v-if="index == 0">
                        <img class='wl-img' src="../assets/images/wl/txt2.png" alt="" v-if="index == 1">
                        <div class='w-item' v-bind:class="{ 'one':index == 0 }">
                            <workItem :winnerType="'wl'"  :columnIndex="0"  :work="item"></workItem>
                        </div>
                    </template> 
                </div>
            </div>
            <div class='w10'>
                <ul class='w-hx'>
                    <li class='w-item' v-for="item in xhw10">
                        <workItem :winnerType="'winner10'"  :columnIndex="0"  :work="item"></workItem>
                    </li>
                </ul>
                <ul class='w-ff'>
                    <li class='w-item' v-for="item in ffw10">
                        <workItem :winnerType="'winner10'"  :columnIndex="0"  :work="item"></workItem>
                    </li>
                </ul>
            </div>
            <div class='apply-fc'>
                <img src="../assets/images/20/head.jpg" alt="">
                <div class="part-panel" data-index='sign'>
                    <h1 class="part-title"></h1>
                    <div class="part-body self-bg">
                        <signTabFc ></signTabFc>
                    </div>
                </div>
                <div  class="part-panel" data-index='song'>
                    <!-- <img src="../assets/images/20/song-head.jpg" alt=""> -->
                    <div class='song-panel'>
                        <template v-if="winner20.length > 0">
                            <template  v-for="item in winner20">
                                <workItem :winnerType="'winner20'"  :columnIndex="0" :work="item"></workItem>
                            </template>
                            <div class='w-btn' v-on:click='score'></div>
                        </template>
                        
                        <div class='no-data' v-else ></div>
                    </div>
                </div>
            </div>
            <div class='team'>
                <div class='team-list'>
                    <ul class='team-xh'>
                        <li class='team-item' v-for="item in xhData" >
                            <div class='item-img'>
                                <img  onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'"
                                 v-bind:src="item.img.replace(/\.(jpg|png|gif)/, `.$1_196x160.$1`)" alt="" v-if="item.img">
                                <img src='../assets/images/index/team-l-bg.jpg'  alt="" v-else>
                                <span></span>
                            </div>
                            <p class='item-name'>{{item.nickName?item.nickName:'待揭晓' }}</p>
                        </li>
                    </ul>
                    <span class='team-vs'></span>
                    <ul class='team-ff'>
                       <li class='team-item' v-for="item in ffData" >
                            <div class='item-img'>
                                <img  onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'"
                                 v-bind:src="item.img.replace(/\.(jpg|png|gif)/, `.$1_196x160.$1`)" alt="" v-if="item.img">
                                <img src='../assets/images/index/team-l-bg.jpg'  alt="" v-else>
                                <span></span>
                            </div>
                            <p class='item-name'>{{item.nickName?item.nickName:'待揭晓' }}</p>
                        </li>
                    </ul>
                    <div class='team-btn' v-on:click='comments'></div>
                </div>
                
            </div>
            <!-- <div class='song-list'>
                <span class='list-bg'></span>
                <ul class=' list'>
                    <li class='li-item'  v-for="item in winnerData" >
                        <workItem :winnerType="'winnerSong'"  :columnIndex="0" :work="item" v-if='item.teamtype'></workItem>
                    </li>
                </ul>
            </div> -->
            <!-- <ul class='mv-list'>
                <li  v-for="item in winnerMvData" >
                    <workItem :winnerType="'winnerMv'"  :columnIndex="0" :work="item"></workItem>
                </li>
            </ul> -->
        </div>
        
        <div class="part-panel">
            <div  class="part-warpper" data-index='sponsor'>
                <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href="javascript:void(0);" ></a>
                        <a class="part-item kugou" href="javascript:void(0);" ></a>
                        <a class="part-item sing" href="javascript:void(0);" ></a>
                    </div>
                </div>
                <div data-index='2'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item " href="javascript:void(0);" ></a>
                    </div>
                </div>
                <div data-index='3'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item za" href="javascript:void(0);" ></a>
                        <a class="part-item yd" href="javascript:void(0);" ></a>
                        <a class="part-item grt" href="javascript:void(0);" ></a>
                        <a class="part-item sy" href="javascript:void(0);" ></a>
                        <p class='txt'>(排序不分先后)</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import workItem from '@/components/work-item'
import signTabFc from '@/components/sign-tab-fc'
export default {
    name: "indexWinner",
    data() {
        return {
            signConfig: this.$winConfig.signConfig,
            winnerData: _fcData[0].data,
            winnerMvData: [],
            tab:  tableTab,
            winner20: [],
            ffData: [
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                }
            ],
            xhData: [
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                },
                {
                    img:"",
                    nickName:"",
                    userId:'',
                }
            ],
            xhw10:[
                {
                    songId: "3675869",
                    songName: "无风的等候",
                    type: "yc",
                    singerId: "34582006",
                    singerName: "周延英",
                    singerUrl:"http://wsing.bssdl.kugou.com/e4ca3775d11c7208a2df3d44ca4702ac.jpg",
                    songUrl: "http://data.5sing.kgimg.com/G138/M00/0C/01/yg0DAFtshxmIIKwnAA_sHOuwcT0AAAWZAEMafoAD-w0942.m4a",
                    number: "599",
                    id: "30130",
                    songPcUrl: "http://5sing.kugou.com/yc/3675869.html###",
                    mid: "3675869",
                    team: 'h1'
                },
                {
                    songId: "3666387",
                    songName: "爱在无风时",
                    type: "yc",
                    singerId: "63663275",
                    singerName: "邵元SY",
                    singerUrl:"http://wsing.bssdl.kugou.com/6f55b9c6a015b32df8e843dc2cfa1190.png",
                    songUrl: "http://data.5sing.kgimg.com/G133/M0A/0E/01/xQ0DAFtemJWIH6weAA1mwMeA_wAAAAxiQLYi2IADWbY088.m4a",
                    number: "426",
                    id: "29715",
                    songPcUrl: "http://5sing.kugou.com/yc/3666387.html###",
                    mid: "3666387",
                    team: 'h2'
                },
                {
                    songId: "3688922",
                    songName: "春画",
                    type: "yc",
                    singerId: "49466363",
                    singerName: "尧顺宇",
                    singerUrl:"http://wsing.bssdl.kugou.com/f0522be3bccbb6b637ad2bf8b59f7bb1.jpg",
                    songUrl:"http://data.5sing.kgimg.com/G136/M00/02/09/KIcBAFt_1hCAWDlLABDn5LhbwcI788.m4a",
                    number: "1931",
                    id: "32920",
                    songPcUrl: "http://5sing.kugou.com/yc/3688922.html",
                    mid: "3688922",
                    team: 'h3'
                },
                {
                    songId: "3689522",
                    songName: "爱在无风时，绽放",
                    type: "yc",
                    singerId: "3837538",
                    singerName: "NL不分",
                    singerUrl:"http://wsing.bssdl.kugou.com/4cc399bcabd460f706542aeb4c4e5906.jpg",
                    songUrl: "http://data.5sing.kgimg.com/G142/M03/0B/18/LocBAFuA-e-AARtCABAJ7RnxtXk785.m4a",
                    number: "2050",
                    id: "33134",
                    songPcUrl: "http://5sing.kugou.com/yc/3689522.html",
                    mid: "3689522",
                    team: 'h4'
                },
                {
                    songId: "3673571",
                    songName: "爱在无风时",
                    type: "yc",
                    singerId: "3901976",
                    singerName: "CY树先生",
                    singerUrl: "http://wsing.bssdl.kugou.com/5240d98170eb427c157aab4e2d246e6c.jpg",
                    songUrl:"http://data.5sing.kgimg.com/G089/M07/0D/04/mQ0DAFtpURmAS3bpABMQW1kNLSQ579.m4a",
                    number: "553",
                    id: "30006",
                    songPcUrl: "http://5sing.kugou.com/yc/3673571.html",
                    mid: "3673571",
                    team: 'h5'
                }
            ],
            ffw10:[
                {
                    songId: "3672212",
                    songName: "爱在无风时",
                    type: "yc",
                    singerId: "8231799",
                    singerName: "_小魂_",
                    singerUrl: "http://wsing.bssdl.kugou.com/92e8505c86d6740be30e53b9da162efd.jpg",
                    songUrl:"http://data.5sing.kgimg.com/G136/M08/19/07/aJQEAFtnw_uINWyiAA4LZdgdnoUAAAf2gFLqDYADgt9381.m4a",
                    number: "536",
                    id: "29951",
                    songPcUrl: "http://5sing.kugou.com/yc/3672212.html",
                    mid: "3672212",
                    team: 'f1'
                },
                {
                    songId: "3639587",
                    songName: "海绵里de氧气",
                    type: "yc",
                    singerId: "65685579",
                    singerName: "唱作人李一桐",
                    singerUrl: "http://wsing.bssdl.kugou.com/e819085bd22e9dac2518e379ea0d56bb.jpg",
                    songUrl:"http://data.5sing.kgimg.com/G084/M05/1B/11/lA0DAFs0k0aICrYEAA6SQtSGVqkAAAdnQHEoxoADpJ5505.m4a",
                    number: "304",
                    id: "29376",
                    songPcUrl: "http://5sing.kugou.com/yc/3639587.html###",
                    mid: "3639587",
                    team: 'f2'
                },
                {
                    songId: "3680738",
                    songName: "爱在无风时",
                    type: "yc",
                    singerId: "35999549",
                    singerName: "Mukyo木西",
                    singerUrl:"http://wsing.bssdl.kugou.com/c846bb97ef4c9b3cd792bb0358e639f2.jpg",
                    songUrl: "http://data.5sing.kgimg.com/G142/M01/1A/01/LocBAFt0PKiIL0CIAA20ZFH9YcYAAAETAHN9KcADbR8590.m4a",
                    number: "1203",
                    id: "30887",
                    songPcUrl: "http://5sing.kugou.com/yc/3680738.html",
                    mid: "3680738",
                    team: 'f3'
                },
                {
                    songId: "3689005",
                    songName: "风之语",
                    type: "yc",
                    singerId: "11083896",
                    singerName: "AsiaChen陈亚",
                    singerUrl:"http://wsing.bssdl.kugou.com/75c50165fa31fb0cf31d067ca70aa970.jpg",
                    songUrl:"http://data.5sing.kgimg.com/G141/M02/06/17/LYcBAFuBCYmAC9K4ABIS4Ne8r9o409.m4a",
                    number: "1985",
                    id: "33018",
                    songPcUrl: "http://5sing.kugou.com/yc/3689005.html",
                    mid: "3689005",
                    team: 'f4'
                },
                {
                    songId: "3684339",
                    songName: "薄荷色",
                    type: "yc",
                    singerId: "55719604",
                    singerName: "纳小米",
                    singerUrl:"http://wsing.bssdl.kugou.com/54b714046e8d5b2705e543922d97bf74.jpg",
                    songUrl:"http://data.5sing.kgimg.com/G135/M01/0C/01/Z5QEAFt5jw2IWTABAAwDdLwxKAYAAAuzAMn4HQADAOM744.m4a",
                    number: "1518",
                    id: "31404",
                    songPcUrl: "http://5sing.kugou.com/yc/3684339.html",
                    mid: "3684339",
                    team: 'f5_1'
                }
            ],
            w10:[
                {
                    songId: "3666387",
                    songName: "《爱在无风时》",
                    type: "yc",
                    singerId: "63663275",
                    singerName: "&nbsp;邵元SY",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-0.png",
                    songUrl: "http://data.5sing.kgimg.com/G133/M0A/0E/01/xQ0DAFtemJWIH6weAA1mwMeA_wAAAAxiQLYi2IADWbY088.m4a",
                    number: "426",
                    id: "29715",
                    songPcUrl: "http://5sing.kugou.com/yc/3666387.html###",
                    mid: "3666387",
                    txt:'第一轮PK得分：95分&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;第二轮PK得分：96.3分'
                },
                {
                    songId: "3672212",
                    songName: "《爱在无风时》",
                    type: "yc",
                    singerId: "8231799",
                    singerName: "&nbsp;_小魂_",
                    singerUrl: "http://static.5sing.kugou.com/topic/mdkt2018/images/fs-1.png",
                    songUrl:"http://data.5sing.kgimg.com/G136/M08/19/07/aJQEAFtnw_uINWyiAA4LZdgdnoUAAAf2gFLqDYADgt9381.m4a",
                    number: "536",
                    id: "29951",
                    songPcUrl: "http://5sing.kugou.com/yc/3672212.html",
                    mid: "3672212",
                    txt: '第一轮PK得分：96.5分 | 第二轮PK得分：95.4分'
                },
                {
                    songId: "3684339",
                    songName: "《薄荷色》",
                    type: "yc",
                    singerId: "55719604",
                    singerName: "&nbsp;纳小米组合",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-2.png",
                    songUrl:"http://data.5sing.kgimg.com/G135/M01/0C/01/Z5QEAFt5jw2IWTABAAwDdLwxKAYAAAuzAMn4HQADAOM744.m4a",
                    number: "1518",
                    id: "31404",
                    songPcUrl: "http://5sing.kugou.com/yc/3684339.html",
                    mid: "3684339",
                    txt: '第一轮PK得分：96分'
                },
                {
                    songId: "3689005",
                    songName: "《风之语》",
                    type: "yc",
                    singerId: "11083896",
                    singerName: "&nbsp;陈亚",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-3.png",
                    songUrl:"http://data.5sing.kgimg.com/G141/M02/06/17/LYcBAFuBCYmAC9K4ABIS4Ne8r9o409.m4a",
                    number: "1985",
                    id: "33018",
                    songPcUrl: "http://5sing.kugou.com/yc/3689005.html",
                    mid: "3689005",
                    txt: '第一轮PK得分：95分'
                },
                {
                    songId: "3675869",
                    songName: "《无风的等候》",
                    type: "yc",
                    singerId: "34582006",
                    singerName: "&nbsp;周延英",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-4.png",
                    songUrl: "http://data.5sing.kgimg.com/G138/M00/0C/01/yg0DAFtshxmIIKwnAA_sHOuwcT0AAAWZAEMafoAD-w0942.m4a",
                    number: "599",
                    id: "30130",
                    songPcUrl: "http://5sing.kugou.com/yc/3675869.html###",
                    mid: "3675869",
                    txt: '第一轮PK得分：93分'
                },
                {
                    songId: "3688922",
                    songName: "《春画》",
                    type: "yc",
                    singerId: "49466363",
                    singerName: "&nbsp;尧顺宇",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-5.png",
                    songUrl:"http://data.5sing.kgimg.com/G136/M00/02/09/KIcBAFt_1hCAWDlLABDn5LhbwcI788.m4a",
                    number: "1931",
                    id: "32920",
                    songPcUrl: "http://5sing.kugou.com/yc/3688922.html",
                    mid: "3688922",
                    txt: '第一轮PK得分：91分'
                },
                {
                    songId: "3680738",
                    songName: "《爱在无风时》",
                    type: "yc",
                    singerId: "35999549",
                    singerName: "&nbspMukyo木西",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-6.png",
                    songUrl: "http://data.5sing.kgimg.com/G142/M01/1A/01/LocBAFt0PKiIL0CIAA20ZFH9YcYAAAETAHN9KcADbR8590.m4a",
                    number: "1203",
                    id: "30887",
                    songPcUrl: "http://5sing.kugou.com/yc/3680738.html",
                    mid: "3680738",
                    txt: '第一轮PK得分：91分'
                },
                {
                    songId: "3689522",
                    songName: "《爱在无风时，绽放》",
                    type: "yc",
                    singerId: "3837538",
                    singerName: "&nbsp;NL不分",
                    singerUrl:"http://static.5sing.kugou.com/topic/mdkt2018/images/fs-7.png",
                    songUrl: "http://data.5sing.kgimg.com/G142/M03/0B/18/LocBAFuA-e-AARtCABAJ7RnxtXk785.m4a",
                    number: "2050",
                    id: "33134",
                    songPcUrl: "http://5sing.kugou.com/yc/3689522.html",
                    mid: "3689522",
                    txt: '第一轮PK得分：91分'
                },
                {
                    songId: "3639587",
                    songName: "《海绵里de氧气》",
                    type: "yc",
                    singerId: "65685579",
                    singerName: "&nbsp;李一桐",
                    singerUrl: "http://static.5sing.kugou.com/topic/mdkt2018/images/fs-8.png",
                    songUrl:"http://data.5sing.kgimg.com/G084/M05/1B/11/lA0DAFs0k0aICrYEAA6SQtSGVqkAAAdnQHEoxoADpJ5505.m4a",
                    number: "304",
                    id: "29376",
                    songPcUrl: "http://5sing.kugou.com/yc/3639587.html###",
                    mid: "3639587",
                    txt: '第一轮PK得分：90分'
                },
                {
                    songId: "3673571",
                    songName: "《爱在无风时》",
                    type: "yc",
                    singerId: "3901976",
                    singerName: "&nbsp;CY树先生",
                    singerUrl: "http://static.5sing.kugou.com/topic/mdkt2018/images/fs-9.png",
                    songUrl:"http://data.5sing.kgimg.com/G089/M07/0D/04/mQ0DAFtpURmAS3bpABMQW1kNLSQ579.m4a",
                    number: "553",
                    id: "30006",
                    songPcUrl: "http://5sing.kugou.com/yc/3673571.html",
                    mid: "3673571",
                    txt: '第一轮PK得分：90分'
                }
            ]
        };
    },
    components: {
        workItem,
        signTabFc
    },
    created: function () {
        let _this = this;
        let formData = {
            sid: _this.signConfig[1].id,
            page: 1,
            order: 4,
            number: 5,
            sign_type: 7
        };
        this.$server.getWorkList(formData).then(function(res){
            _this.winnerMvData = res.data;
            _this.getWinner20();
        });
        // setInterval(function(){
        //     _this.getWinner20();
        // },900000);

        this.getSong();
    },
    mounted:function(){
        var _this = this;
        eventbus.$on("reloadSong", function (res) {
            if(res.type == 'success'){
                _this.getSong();
            }
        });  
    },
    methods:{
        getSong: function(){
            let _this = this;
            this.$server.getWorkList({
                sid: _this.signConfig[2].id,
                page: 1,
                order: 1,
                number: 25,
            }).then(function(res){
                _this.winner20 = res.data;
            });
        },
        getWinner20: function(){
            let _this = this;
            this.$http.get('http://5sing.kugou.com/subject/api/complex/md50into20', {}).then((response) => {
                let res = response.body.data;
                let w20 = {};
                _this.ffData = res.feifan;
                _this.xhData = res.xinghai;
                for(let f of res.feifan){
                    if(f.nickName){
                        w20[f.userId] = f;
                        w20[f.userId].type = 2;   //2为非凡战队  3为海星战队
                    } 
                }
                for(let  x of res.xinghai){
                    if(x.nickName){
                        w20[x.userId] = x;
                        w20[x.userId].type = 3;   
                    }
                } 
                for(let w of _this.winnerData){
                    if(w20[w.singerId]){
                        w.teamtype =  w20[w.singerId].type;
                        w.singerUrl = w20[w.singerId].img;
                        w.singerName = w20[w.singerId].nickName;
                    }else{
                        w.teamtype =  1;
                    }
                }
                _this.$set(_this.winnerData, _this.winnerData);
            });
        },
        comments:function(){
            this.$router.replace({
                name: 'comment',
                path: '/comment',
                params: {
                    scroll: 1000,
                }
            });
            // this.$tipsBox.tips({
            //     message: "导师点评中，敬请期待~"
            // });
        },
        score:function(){
            this.$router.replace({
                name: 'score',
                path: '/score',
                params: {
                    scroll: 1000,
                }
            });
            // this.$tipsBox.tips({
            //     message: "评审团正在计分，敬请期待~"
            // });
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" >
@import "../assets/sass/cmn.scss";
.part-panel[data-index="winnerTable"] {
    width: 1100px;
    background: none;
    padding: 0;
    margin-bottom: 50px;
    table{
        width: 1000px;
        margin: 0 auto;
        border-top: 1px solid #fff;
        border-left: 1px solid #fff;
        border-collapse: collapse;
        border-spacing: 0;
    }
    th,td{
        border-bottom:1px solid #fff;
        border-right:1px solid #fff;
        padding:10px 0;
        vertical-align:middle;
        text-align:center;
        color:#fff;
        font-size:14px;
    }
    th{
        padding:15px 0;
        font-weight:bold;
        font-size:20px;
        color: #fff;
    }
    td a{
        text-decoration: none;
        color:inherit;
        &:hover{
            color:#7be5ff;
        }
    }
    .st-wrap {
        padding-bottom: 50px;
    }
    .item-play{
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: url(componentsImgPath('index/w-pause.png')) center center no-repeat;
    }
    .status-pause{
        background: url(componentsImgPath('index/w-play.png')) center center no-repeat;
    }
}
.w10{
    width: 1000px;
    padding-top: 185px;
    padding-bottom: 289px;
    margin: 0 auto;
    background: url(componentsImgPath('10/bg.png')) center top no-repeat;
    .w-item{
        display: inline-block;
        width: 484px;
        margin-bottom: 40px;
        img{
            width: 100%;
        }
        .content{
            position: relative;
            width: 442px;
            padding: 15px 0 10px 22px;
            margin: 0 auto;
            text-align: left;
            background: url(componentsImgPath('10/b.png')) center top no-repeat;
            .head{
                position: relative;
                display: inline-block;
                width: 90px;
                height: 60px;
                margin-right: 25px;
                vertical-align: middle;
                background-color: #000;
                cursor: pointer;
                img{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
                .btn{
                    position: absolute;
                    top: 0;
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: url(componentsImgPath('10/pause.png')) center top no-repeat;
                    background-size: 100% 100%;
                }
                .play{
                    background: url(componentsImgPath('10/play.png')) center top no-repeat;
                    background-size: 100% 100%;
                }
            }
            .txt{
                display: inline-block;
                //width: 46%;
                vertical-align: middle;
                text-align: left;
                .txt-item{
                    display: block;
                    padding-top: 4px;
                    color: #181f27;
                    font-size: 18px;
                }
            }
            .share{
                position: absolute;
                right: 60px;
                top: 30px;
                display: inline-block;
                width: 54px;
                height: 30px;
                background: url(componentsImgPath('10/share.png')) center top no-repeat;
                vertical-align: middle;
                cursor: pointer;
            }
        }
    }
    .w-hx{
        margin-top: 40px;
        text-align: center;
        .w-item:nth-child(1){
            display: block;
            margin-left: 500px;
        }
    }
    .w-ff{
        margin-top: 100px;
        text-align: center;
        .w-item:nth-child(1){
            display: block;
            margin-left: 10px;
        }
    }
}
.w-last{
    width: 1000px;
    margin: 0 auto;
    .wl-cnt{
        width: 1100px;
    }
    .w-item{
        display: inline-block;
        width: 488px;
        margin-bottom: 40px;
        margin-right: 25px;
        .content{
            position: relative;
            width: 488px;
            padding: 20px 0 10px 10px;
            margin: 0 auto;
            text-align: left;
            background: url(componentsImgPath('wl/bg1.png')) center top no-repeat;
            background-size: 100% 100%;
            box-sizing: border-box;
            .head{
                position: relative;
                display: inline-block;
                width: 110px;
                height: 110px;
                margin-right: 25px;
                vertical-align: middle;
                background-color: #000;
                cursor: pointer;
                img{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
                .btn{
                    position: absolute;
                    bottom: -10px;
                    display: block;
                    width: 110px;
                    height: 80px;
                    background: url(componentsImgPath('10/pause.png')) center top no-repeat;
                    background-size: 100% 100%;
                }
                .play{
                    background: url(componentsImgPath('10/play.png')) center top no-repeat;
                    background-size: 100% 100%;
                }
            }
            .txt{
                display: inline-block;
                vertical-align: middle;
                text-align: left;
                .txt-item{
                    display: block;
                    padding-top: 4px;
                    color: #181f27;
                    font-size: 22px;
                }
                p{
                    width: 300px;
                    margin-top: 10px;
                    padding: 5px 10px;
                    font-size: 14px;
                    background-color: #fcff2a;
                }
            }
            .share{
                position: absolute;
                right: 35px;
                top: 40px;
                display: inline-block;
                width: 63px;
                height: 35px;
                background: url(componentsImgPath('10/share.png')) center top no-repeat;
                background-size: 100% 100%;
                vertical-align: middle;
                cursor: pointer;
            }
        }
    }
    .wl-img{
        display: block;
        margin-bottom: 5px;
    }
    .one{
        margin-bottom: 70px;
        .content{
            width:568px;
            background: url(componentsImgPath('wl/bg.png')) center top no-repeat;
            .share{
                right: 60px;
            }
            .txt{
                p{
                    width: 370px;
                    font-size: 16px;
                }
            }
        }
    }
}
.apply-fc{
    //margin-top: -55px;
    text-align: center;
    .part-panel[data-index="sign"]{
        margin-top: 50px;
        .part-title{
            background-image: url(componentsImgPath('index/title-sign.png'));
        }
    }
    .part-panel[data-index="song"]{
        width: 1004px;
        margin-bottom: 0;
        background-color: rgba(255,255,255,.2);
        img{
            display: block;
        }
        .song-panel{
            margin: 0 auto;
            border: 3px solid #fff;
            text-align: left;
            .yc-wrap{
                width: 190px;
                margin: 20px 0  0 8px;
            }
            .wk-header{
                cursor: pointer;
            }
            .wk-footer{
                background-color: #f2eff8;
            }
            .song-name a{
                font-weight: 600;
            }
            .song-author,.song-author a{
                color: #542eab;
            }
            .btns{
                height: 22px;
                text-align: right;
            }
            .w-btn{
                display: block;
                width: 185px;
                height: 113px;
                margin: 60px auto 30px;
                cursor: pointer;
                background:url(componentsImgPath('20/btn.png'))  center top  no-repeat;
            }
            .w-share{
                display: inline-block;
                width: 35px;
                height: 22px;
                background:url(componentsImgPath('20/share.png'))  center top  no-repeat;
            }
        }
    }
}
.team{
    position: relative;
    //margin-top: -55px;
    margin-bottom: 30px;
    padding-top: 424px;
    padding-bottom: 80px;
    background:url(componentsImgPath('index/team-bg.jpg'))  center top  no-repeat,
    url(componentsImgPath('index/team-bg1.png'))  center bottom  no-repeat;
    background-size: 100%;
    .team-list{
        padding-bottom: 26px;
        background-color: #fbefff;
        font-size: 0;
        .team-xh,.team-ff{
            display: inline-block;
            width: 475px;
            padding: 30px 1px;
            vertical-align: top;
        }
        .team-vs{
            display: inline-block;
            width: 143px;
            height: 1301px;
            margin-top: -74px;
            background:  url(componentsImgPath('index/team-vs.png'))  center top  no-repeat;
            vertical-align: top;
        }
        .team-xh{
            .team-item{
                margin-left: 28px;
            }
        }
        .team-ff{
            text-align: right;
            padding-left: 4px;
            .team-item{
                margin-right: 25px;
            }
        }
        .team-item{
            display: inline-block;
            margin-top: 36px;
            .item-img{
                position: relative;
                width: 205px;
                height: 168px;
                padding-top: 2px;
                padding-left: 8px;
                box-sizing: border-box;
                img{
                    width: 196px;
                    height: 160px; 
                    border-radius: 5px;
                }
                span{
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: url(componentsImgPath('index/team-l.png'))  center top  no-repeat;
                }
            }
            .item-name{
                padding-top: 10px;
                font-size: 20px;
                color: #2b1f79;
                text-align: center;
            }
        }
        .team-btn{
            display: block;
            width: 205px;
            height: 57px;
            margin: 25px auto 0;
            cursor: pointer;
            background:url(componentsImgPath('index/team-btn.png'))  center top  no-repeat;
        }
    }
}
.song-list{
    position: relative;
    overflow: hidden;
    width: 1190px;
    .list-bg{
        position: absolute;
        top: 207px;
        left: 0;
        display: block;
        width: 25px;
        height: 100%;
        background-image:url(componentsImgPath('index/w-bg1.png')) ,
    }
    .list{
        padding: 120px 0 20px 20px;
        background: url(componentsImgPath('index/w-bg.png')) 0 0 no-repeat;
    }
    .li-item{
        position: relative;
        display: inline-block;
        width: 171px;
        margin: 0 22px 70px ;
        vertical-align: middle;
        .item-header{
            position: relative;
            width: 171px;
            height: 171px;
            background-image: url(componentsImgPath('index/w-header.png'));
            background-size: 100% 100%;
            cursor: pointer;
            img{
                width: 135px;
                height: 135px;
                margin: 17px;
                border: 1px solid #10f2fb;
                border-radius: 50%;
            }
            // .item-play{
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     display: block;
            //     width: 100%;
            //     height: 100%;
            //     background: url(componentsImgPath('index/w-pause.png')) center center no-repeat;
            // }
            // .status-pause{
            //     background: url(componentsImgPath('index/w-play.png')) center center no-repeat;
            // }
            .item-icon{
                position: absolute;
                top: -70px;
                left: 35%;
                display: block;
                width: 95px;
                height: 95px;
                background: url(componentsImgPath('index/cyf.png')) center center no-repeat;
            }
            .item-icon-h{
                background: url(componentsImgPath('index/hac.png')) center center no-repeat;
            }
        }
        .item-share{
            display: block;
            position: absolute;
            top: 160px;
            right: 0;
            width: 39px;
            height: 26px;
            margin-right: 1px;
            cursor: pointer;
            background: url(componentsImgPath('index/w-share.png')) center top no-repeat;
        }
        .item-author,.item-name{
            display: block;
            width: 100%;
            text-align: center;
            color: #333;
            border: 1px solid #10f2fb;
            border-radius: 5px;
            background-color:  #fff;

            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
        }
        .item-author{
            height: 36px;
            margin-top: 25px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        .item-name{
            height: 46px;
            margin-top: 8px;

            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            
        }
    }
}
.mv-list{
    width: 1200px;
    padding-top:133px;
    background: url(componentsImgPath('index/w-mvbg.png')) 10px 0 no-repeat;
    li{
        position: relative;
        display: inline-block;
        width: 189px;
        height: 211px;
        margin: 0 11px;
    }
    .work-panel{
        display: block;
    }
    .mv-img{
        display: block;
        width: 175px;
        height: 145px;
        margin: 18px  auto 0;
        border-top-left-radius: 17px;
        border-top-right-radius: 6px;
        border-bottom-left-radius: 17px;
        border-bottom-right-radius: 5px;
    }
    .mv-item{
        position: absolute;
        top: 0;
        width: 100%;
        background: url(componentsImgPath('index/w-mv.png')) 0 0 no-repeat;
    }
    .item-head{
       position: relative;
       width: 175px;
       height: 145px;
       margin: 18px  auto 0;
       .mv-play {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            cursor: pointer;
            background: url(componentsImgPath('index/w-pause.png')) center center no-repeat;
        }
       .number {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 25px;
            line-height: 25px;
            padding: 0 8px;
            font-size: 0;
            color: #fff;
            box-sizing: border-box;
            span{
                display: inline-block;
                font-size: 12px;
            }
            .time{
                width: 30%;
            }
            .play{
                width: 70%;
                text-align: right;
            }
        }
    }
    .item-btm{
        position: relative;
        width: 83%;
        margin: 5px auto 0;
        font-size: 14px;
        line-height: 1.5;
        .mv-name{
            display: block;
            text-align: center;
            cursor: pointer;
            color: #000;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        .mv-auther{
            display: block;
            width: 72%;
           color: #000;
            cursor: pointer;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        .mv-share{
            position: absolute;
            bottom: 0;
            right: 0;
            color: #000;
            cursor: pointer;
            i{
                display: inline-block;
                width: 11px;
                height: 11px;
                margin-right: 5px;
                background: url(componentsImgPath('index/w-share1.png')) center center no-repeat;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/index-winner.vue